// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLockOutlinedSvg from "@fishx/icons-svg/es/asn/PLockOutlined";
import FishxIcon from '../components/FishxIcon';

var PLockOutlined = function PLockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLockOutlinedSvg
  }));
};

PLockOutlined.displayName = 'PLockOutlined';
export default React.forwardRef(PLockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLockOutlined.js
// module id = 3498
// module chunks = 0